import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { FormBuilder } from '@angular/forms';
import { UserListSortOption } from 'src/core/models/generic-lookup-type/identity/user-list-sort-option.glt';
import { Operators } from 'src/core/models/request/operator.enum';
import { CAUserDto } from 'src/core/models/administration/user/CAUser.dto';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterPanelStateModel } from 'src/ca-shared/filter-panel/models/filter-panel.state-model';
import { FilterItemDto } from 'src/core/models/request/filter-item.dto';
import { RoleDto } from 'src/core/models/shared/role.dto';
import { DepartmentFilterModeOption } from 'src/core/models/generic-lookup-type/department/department-filter-mode-option.glt';
import { FilterHelper } from 'src/core/helpers/filter-helper';
import { ExcelService } from 'src/core/services/excel/excel.service';
import { ExcelType } from 'src/core/models/enum/excel-type.enum';
import { ToasterService } from '@abp/ng.theme.shared';
import { PrivacyService } from 'src/core/services/auth/privacy.service';

@Component({
  selector: 'ca-user-list-toolbar',
  templateUrl: './user-list-toolbar.component.html',
  styleUrls: ['./user-list-toolbar.component.scss'],
  standalone: false,
})
export class UserListToolbarComponent implements OnInit {
  @Output()
  addNewClick = new EventEmitter();

  @Output()
  refreshRequested = new EventEmitter();

  @Output()
  isActiveFilterChangeRequest: EventEmitter<{
    includePassiveUsers: boolean;
  }> = new EventEmitter();

  @Output()
  importFromFileClick = new EventEmitter();

  @Output()
  exportUsersClick = new EventEmitter();

  @Input()
  selection: SelectionModel<CAUserDto>;

  toolbarForm = null;

  get canExport(): boolean {
    return this.privacyService.hasUserPrivacyRequirements();
  }

  get selectedCount() {
    return this.selection.selected.length;
  }

  doSearch() {
    this.onIncludePassiveUsersChange();
  }

  addNew() {
    this.addNewClick.emit();
  }

  refresh(): void {
    this.refreshRequested.emit();
  }

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private operators: Operators,
    private excelService: ExcelService,
    private toastr: ToasterService,
    private privacyService: PrivacyService
  ) {
    this.toolbarForm = this.fb.group({
      includePassiveUsers: [false],
      sort: [UserListSortOption.usernameAscending],
    });
  }

  onIncludePassiveUsersChange() {
    const val: boolean = this.toolbarForm.get('includePassiveUsers').value;
    this.isActiveFilterChangeRequest.emit({
      includePassiveUsers: val,
    });
  }

  importFromFile(eventArgs) {
    this.importFromFileClick.emit();
  }

  exportUsers(eventArgs) {
    const state = this.store.selectSnapshot<FilterPanelStateModel>(state => state.FilterPanelState);
    const filterGroups = state.values['user-list'];
    let filters = this.setFilterValues(filterGroups);
    filters.push({
      field: 'includePassives',
      operator: this.operators.Equals,
      value: this.toolbarForm?.get('includePassiveUsers').value,
    });
    let sorters = [
      {
        field: 'Name',
        direction: 'ASC',
      },
    ];
    this.excelService.exportList(filters, sorters, ExcelType.User, null).subscribe(() => {
      this.toastr.success('User::ExportListRequestSuccessful');
    });
  }

  setFilterValues(filterGroups: any) {
    let filters: FilterItemDto[] = [];
    if (filterGroups) {
      for (const key of Object.keys(filterGroups)) {
        let value = filterGroups[key].value;
        if (key == 'quickSearchTerm' && value != null && value != '') {
          filters.push({
            field: 'quickSearchTerm',
            operator: this.operators.Equals,
            value: value,
          });
        } else if (key == 'role') {
          if (value && value.length > 0) {
            const ids: string[] = [];

            for (let i = 0; i < value.length; i++) {
              const role = value[i] as RoleDto;
              ids.push(role.id);
            }

            filters.push({
              field: 'roleId',
              operator: this.operators.In,
              value: ids,
            });
          }
        } else if (key == 'department') {
          let departmentOperator = this.operators.In;
          if (
            Number(filterGroups[key].value?.filterModeId) ==
            DepartmentFilterModeOption.AllDepartmentsExceptSelectedDeparment
          ) {
            departmentOperator = this.operators.NotContains;
          }
          filters = filters.concat(
            FilterHelper.getFilterValueFromArrayObject(
              filterGroups[key].value.selectedDepartments,
              departmentOperator,
              'departmentId',
              'id'
            )
          );
        } else if (key == 'lastLoginDate' && value?.id != null) {
          filters.push({
            field: 'lastLoginDate',
            operator: this.operators.Equals,
            value: value.id,
          });
        }
      }
    }

    return filters;
  }

  ngAfterViewInit() {}
  ngOnInit() {}
}
